var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"secondary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],1),_c('v-card-text',[(_vm.loaded)?_c('apexchart',{attrs:{"type":"pie","width":"100%","height":"400","options":_vm.chartOptions,"series":_vm.series}}):_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"image"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }